<div class="center" (click)="onMouseClick($event)">
   <div class="singleLineForProgSettings">
      <div style="float:right;">
        <span>
          <fa-icon [icon]="faCog"></fa-icon>
        </span>
        <div class="btn" style="padding-top:0px;" data-backdrop="static" data-toggle="modal" data-target="#foReportSetting">Report Settings</div>
      </div>
   </div>

   <div class="half-width">
      <div class="tabs" (click)="setState(1)" [ngClass]="multiReport.indexOf(1) > -1 ? 'selected': ''">
         <span>Standard Solution Report
           <fa-icon [icon]="faInfoCircle" id="StandardRptInfoBtn" (mouseenter)="showHideInfoToggle('StandardRptInfo')" (mouseleave)="showHideInfoToggle('StandardRptInfo')"></fa-icon>
               <div id="divStandardRptInfo">
                   <div class="InfoContent">
                     A detailed report showing all solutions side by side along with the specifics of each stage of filtration.
                   </div>
                   <div id="arrow" data-popper-arrow></div>
               </div>
         </span>
         <span *ngIf="multiReport.indexOf(1) > -1">
            <fa-icon class="paddingright5" [icon]="faCheck"></fa-icon>
         </span>
      </div>
      <div class="tabs" (click)="setState(2)" [ngClass]="multiReport.indexOf(2) > -1 ? 'selected': ''">
         <span>Comparison Report
            <fa-icon [icon]="faInfoCircle" id="ComparisonRptInfoBtn" (mouseenter)="showHideInfoToggle('ComparisonRptInfo')" (mouseleave)="showHideInfoToggle('ComparisonRptInfo')"></fa-icon>
               <div id="divComparisonRptInfo">
                  <div class="InfoContent">
                     Comparison Report
                  </div>
                  <div id="arrow" data-popper-arrow></div>
               </div>
         </span>
         <span *ngIf="multiReport.indexOf(2) > -1">
            <fa-icon class="paddingright5" [icon]="faCheck"></fa-icon>
         </span>
      </div>

      <div *ngIf="UserIsAdmin===true" class="tabs flex-column">
         <div class="space-between" (click)="toggleDrop()">
            <span>Graph Series in Excel Format</span>
            <span>
               <fa-icon *ngIf="showDropdown" class="padd5" [icon]="faAngleUp"></fa-icon>
               <fa-icon *ngIf="!showDropdown" class="padd5" [icon]="faAngleDown"></fa-icon>
            </span>
         </div>
      
         <div *ngIf="showDropdown" class="row-2">
            <ul *ngFor="let solution of solutions; let i = index;" class="flex-column">
               <li class="line"></li>
               <li class=" listitem">
                  <div class="listdrop" (click)="setChildState(i)" [ngClass]="childReport.indexOf(i) > -1 ? 'selected': ''">
                     <span>{{solution.solutionName}}</span>
                     <span *ngIf="childReport == i">
                        <fa-icon [icon]="faCheck"></fa-icon>
                     </span>
                  </div>
               </li>
            </ul>
         </div>
      </div>

      <div class="tabs" (click)="setState(6)" [ngClass]="multiReport.indexOf(6) > -1 ? 'selected': ''">
         <span>All of the above
           <fa-icon [icon]="faInfoCircle" id="AllRptInfoBtn" (mouseenter)="showHideInfoToggle('AllRptInfo')" (mouseleave)="showHideInfoToggle('AllRptInfo')"></fa-icon>
               <div id="divAllRptInfo">
                  <div class="InfoContent">
                     Generate all reports.
                  </div>
                  <div id="arrow" data-popper-arrow></div>
               </div>
         </span>
         <span *ngIf="multiReport.indexOf(6) > -1">
            <fa-icon class="paddingright5" [icon]="faCheck"></fa-icon>
         </span>
      </div>
   </div>

   <div class="modal fade" id="foReportSetting" tabindex="-1" role="dialog" aria-labelledby="foCalculate" aria-hidden="true" >
      <div class="modal-dialog modal-dialog-centered" role="document">
         <div class="foReportSetting">
            <div class="modal-content">
               <div class="modal-header">
                  <span><h5 class="modal-title" id="progsettingpopup">Report Settings</h5></span>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)='triggerCancelFromRptSettings()' style="margin-right:5%;background-color: white; border: none;">
                     <span aria-hidden="true">&times;</span>
                  </button>
               </div>
               <div class="modal-body" style="width:800px;">
                  <div class="formGroup formRow" style="margin-left:1%;">
                     <div class="formGroup">
                        <label>Check below to <label style="color:green;">show</label> the information in reports :</label>                                             
                     </div>                    
                  </div>

                  <!-- Modified by PP(2023-06-16) : Add Check All button - START -->
                  <div class="formGroup formRow" style="margin-left:1%;">
                     <div class="btnCheckAll">                        
                        <div class="checkAllBtn" style="align-items:center;">
                           <button class="checkAllBtn" (click)='triggerCheckAllButton()'>
                              <span class='space'>{{sharedService.checkUncheckLabel}}</span>
                           </button>
                        </div>
                     </div>
                  </div>
                  <!-- Modified by PP(2023-06-16) : Add Check All button - END -->

                  <div class="formGroup formRow" style="margin-left:1%;">
                     <div class="formGroup">
                        <table width="100%">
                           <tr>
                              <td width="30%">                                 
                                 <input type="checkbox" id="chkContaminationInfo" name=chkContaminationInfo value={{reportSettings.contaminationInformation}} (change)="onCheckBoxChange($event)">  Contamination Information
                              </td>
                              <td width="15%">
                                 <input type="checkbox" id="chkFilterSize" name=chkFilterSize value={{reportSettings.filterSize}} (change)="onCheckBoxChange($event)">  Filter Size
                              </td>
                              <td width="20%">
                                 <input type="checkbox" id="chkNumberOfFilter" name=chkNumberOfFilter value={{reportSettings.numberOfFilter}} (change)="onCheckBoxChange($event)">  Number of Filters
                              </td>
                              <td width="25%">                                 
                                 <input type="checkbox" id="chkWeightOfAdsorbant" name=chkWeightOfAdsorbant value={{reportSettings.weightOfAdsorbant}} (change)="onCheckBoxChange($event)">  Weight of adsorbant
                              </td>
                           </tr>                      
                        </table>
                        <table width="100%">
                           <tr>
                              <td width="30%">
                                 <input type="checkbox" id="chkTotIndicativeWeight" name=chkTotIndicativeWeight value={{reportSettings.totalIndicativeWeight}} (change)="onCheckBoxChange($event)">  Total Indicative Weight
                              </td>
                              <td width="15%">
                                 <input type="checkbox" id="chkFrontVelocity" name=chkFrontVelocity value={{reportSettings.frontVelocity}} (change)="onCheckBoxChange($event)">  Front Velocity
                              </td>
                              <td width="20%">
                                 <input type="checkbox" id="chkPressureDrop" name=chkPressureDrop value={{reportSettings.pressureDrop}} (change)="onCheckBoxChange($event)">  Pressure Drop
                              </td>
                              <td width="25%">
                                 <input type="checkbox" id="chkContactTime" name=chkContactTime value={{reportSettings.contactTime}} (change)="onCheckBoxChange($event)">  Contact Time
                              </td>
                           </tr>
                        </table>
                     </div>                   
                  </div>

                  <!-- <div class="formGroup formRow" style="margin-left:1%; margin-top:5%;">
                     <div class="formGroup">
                        <label>Check below to email reports to me :</label>                                             
                     </div>                    
                  </div>
                  <div class="formGroup formRow" style="margin-left:1%;">
                     <div class="formGroup">
                        <input type="checkbox" id="chkEmailToMe" name=chkEmailToMe value={{reportSettings.emailToMe}} (change)="onCheckBoxChange($event)">  Email to me
                     </div>
                  </div> -->

                  <div class="formGroup formRow" style="margin-top:5%;">
                     <div class="tabs flex-column">
                        <div class="space-between" (click)="toggleDrop()">
                           <span>Edit namings in Solutions</span>                           
                        </div>

                        <div class="row-2">
                           <ul *ngFor="let repInfo of currentReportInfo.ReportInfoBySol; let j = index;" class="flex-column">                            
                              <!-- <li class="line"></li> -->
                              &nbsp;
                              &nbsp;
                              <li class=" listitem">
                                 <div class="listdrop" (click)="setChangeMediaInfoState(j)" [ngClass]="selectedSolutionToChangeName.indexOf(j) > -1 ? 'selected': ''">
                                    <span>{{repInfo.solutionName}}</span>                                                                                                   
                                 </div>
                                 &nbsp;
                                 &nbsp;
                                 <div id="divChangeMedianameForSol{{j}}" class="row-2" style="display:none;">
                                    <div class="title16px">Edit naming for this solution</div>                                                               
                                    <div class="formgroup" *ngFor="let item of repInfo.solDetails; let k = index;">                                       
                                       <table width="100%" >
                                          <tr>
                                             <td width="25%">
                                                <span> </span>
                                             </td>
                                             <td width="25%">
                                                <span class="title16pxBold">Filter Group</span>
                                             </td>
                                             <td width="25%">
                                                <span class="title16pxBold">Filter Type</span>
                                             </td>
                                             <td width="25%">
                                                <span class="title16pxBold">Media</span>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td width="25%">
                                                <span class="title15px">Media {{item.combinationID}}</span>
                                             </td>
                                             <td width="25%">
                                                <span class="title15px">{{item.molecularGroup}}</span>
                                             </td>
                                             <td width="25%">
                                                <span class="title15px">{{item.molecularType}}</span>
                                             </td>
                                             <td width="25%">
                                                <span class="title16px">{{item.filterName}}</span>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td width="25%">
                                                <span></span>
                                             </td>
                                             <td width="25%">
                                                <input type="text" class="input-field" name="newFilterGroup" [(ngModel)]="item.newFilterGroup" (keydown)="sharedService.preventTabKey($event)">                                                  
                                             </td>
                                             <td width="25%">
                                                <input type="text" class="input-field" name="newFilterType" [(ngModel)]="item.newFilterType" (keydown)="sharedService.preventTabKey($event)"> 
                                             </td>
                                             <td width="25%">
                                                <input type="text" class="input-field" name="newMedia" [(ngModel)]="item.newMedia" (keydown)="sharedService.preventTabKey($event)"> 
                                             </td>
                                          </tr>
                                       </table>
                                       &nbsp;
                                       &nbsp;
                                    </div>
                                    &nbsp;                                                                   
                                 </div>                          
                              </li>
                           </ul> 
                                       
                        </div>
           
                     </div>
                  </div>
         
                  <div class="btnGroupPrgSetting">
                     <div class="cancel pointer" data-dismiss="modal" (click)='triggerCancelFromRptSettings()'>Cancel</div>
                     <div class="next-button-content" style="align-items:center;">
                        <button class="button-content ripple" data-dismiss="modal" (click)='triggerDoneFromRptSettings()'>
                           <span class='space'>Done</span>
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
    </div>

   <div class="next-button-content">
       <button class="button-content ripple" (click)="prepareRptList()">
          <span class='space'>Generate</span> <fa-icon [icon]="faAngleRight"></fa-icon>
      </button>
    </div>
</div>

<div class="d-flex justify-content-center cover-spin" *ngIf="loading">
   <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
   </div>
</div>
